import { TeamOutlined } from '@ant-design/icons';
import {
  ConfigFormItem,
  getWidgetProps,
  RichTextAdvancedRender,
  type IWidgetComponentProps,
} from '@framework/engine';
import { Card, Space } from 'antd';
import type { IElectoralListChooserWidget } from './IElectoralListChooserWidget';

export interface IElectoralListChooserWidgetPreviewProps
  extends IWidgetComponentProps<IElectoralListChooserWidget> {}

/**
 * Anteprima statica del widget di scelta lista elettorale: icona, etichetta e
 * numero di liste configurate.
 */
export function ElectoralListChooserWidgetPreview(
  props: Readonly<IElectoralListChooserWidgetPreviewProps>,
) {
  const options = getWidgetProps(props);
  const { widget } = props;

  const listCount = widget.electoralListIds?.length ?? 0;
  const listLabel = listCount === 1 ? 'lista' : 'liste';

  return (
    <ConfigFormItem
      name={'string'}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={<RichTextAdvancedRender inline text={options.helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      <Card size="small">
        <Space align="center">
          <TeamOutlined />
          <span>
            Scelta lista elettorale
            {listCount > 0 ? ` (${listCount} ${listLabel})` : ''}
          </span>
        </Space>
      </Card>
    </ConfigFormItem>
  );
}
